var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pre',{staticClass:"mt-15"},[_vm._v("  "),_c('code',{staticClass:"html",domProps:{"innerHTML":_vm._s(_vm.formattedHtml)}}),_vm._v("\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }